export enum HaggleEmailType {
	HaggleStartEmail = 'haggle_start_email',
	HaggleNotificationReminderEmail = 'haggle_notification_reminder_email',
}

export enum ProductCardType {
	Home = 'home',
	Store = 'store',
	Admin = 'admin',
}
